<template>
    <timeline-list>
        <timeline-item 
        v-for="item in listData"
        :key="item.id"
        :color="getBadge(item.scheme.name)"
        icon="bell-55"
        :userId="item.id"
        :imgUrl="cleanImg(item.photo_link)"
        :title="item.firstname +' '+ item.lastname"
        :date-time="item.updated_at"
        :badges="[item.scheme.name, item.state.name]"
        />
    </timeline-list>
</template>

<script>
import TimelineList from "@/views/components/dashboard/UpdatedBeneficiaries/List.vue";
import TimelineItem from "@/views/components/dashboard/UpdatedBeneficiaries/Item.vue";

export default
{
    name : "updated-beneficiary-layout",
    components : {
        TimelineList,
        TimelineItem,
    },
    props : {
        listData : {
            type : Array,
            default : []
        }
    },

    methods :
    {
        getBadge(type)
        {
            var data = '';

            switch(type)
            {
                case 'TraderMoni' : data = 'success';break;
                case 'MarketMoni' : data = 'warning';break;
                case 'FarmerMoni' : data = 'info';break;
                default : data = 'secondary';
            }

            return data;
        },
        
        cleanImg(img)
        {
            if(img!==null&&img!=='')
            {
                return img;
            }

            return '';
        }
    },
}
</script>